<template>
  <v-container
    fluid
    tag="section"
  >
    <v-card>
      <v-card-text>
        <v-row dense>
          <v-col
            cols="12"
            sm="3"
          >
            <skud-place-select />
          </v-col>
          <v-col
            cols="12"
            sm="9"
            class="d-sm-flex justify-end align-center"
          >
            <v-btn
              color="primary"
              outlined
              small
              :disabled="!place || binding === true"
              @click="openKey('bind')"
            >
              Привязать ключ
            </v-btn>
            <v-btn
              color="primary"
              outlined
              small
              class="ml-2"
              :disabled="!place || binding === false"
              @click="openKey('replace')"
            >
              Заменить ключ
            </v-btn>
          </v-col>
        </v-row>
        <v-alert
          v-if="!place"
          type="info"
          outlined
          class="mt-4 mb-0"
        >
          Выберите место
        </v-alert>
        <template v-else>
          <v-alert
            v-if="bindingLoading"
            type="info"
            outlined
            class="mt-4 mb-0"
          >
            Проверка привязки…
          </v-alert>
          <v-alert
            v-else-if="binding === true"
            type="success"
            outlined
            class="mt-4 mb-0"
          >
            API-ключ привязан к месту
          </v-alert>
          <v-alert
            v-else-if="binding === false"
            type="warning"
            outlined
            class="mt-4 mb-0"
          >
            API-ключ не привязан
          </v-alert>
          <v-alert
            v-else
            type="info"
            outlined
            class="mt-4 mb-0"
          >
            Статус привязки неизвестен
          </v-alert>
        </template>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialog_key.show"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ dialog_key.mode === 'bind' ? 'Привязать ключ' : 'Заменить ключ' }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="keyForm">
            <v-text-field
              v-model="dialog_key.api_key"
              label="API-ключ"
              :rules="keyRules"
              outlined
              dense
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            :loading="actionLoading"
            @click="saveKey()"
          >
            <span class="mx-4">Сохранить</span>
          </v-btn>
          <v-btn
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="dialog_key.show = false"
          >
            <span class="mx-4">Отмена</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import SkudPlaceSelect from '@/views/skud/components/SkudPlaceSelect.vue'
import { SkudBrskService } from '@/views/skud/shared/services/skud-brsk-service'

export default {
  name: 'SkudBrskPanel',
  components: {
    SkudPlaceSelect
  },
  data () {
    return {
      svc: null,
      actionLoading: false,
      bindingLoading: false,
      // null = неизвестно (ошибка/эндпоинт ещё не реализован в Charon)
      binding: null,
      keyRules: [
        v => /^[A-Za-z0-9_-]{16,256}$/.test(v) || '16–256 символов: латиница, цифры, _, -'
      ],
      dialog_key: { show: false, mode: 'bind', api_key: '' }
    }
  },
  computed: {
    place () {
      return this.$store.state.skud_place
    }
  },
  watch: {
    place () {
      this.loadBinding()
    }
  },
  mounted () {
    this.svc = new SkudBrskService()
    this.loadBinding()
  },
  methods: {
    async loadBinding () {
      if (!this.place || !this.svc) {
        this.binding = null
        return
      }
      this.bindingLoading = true
      const res = await this.svc.getBinding(this.place)
      this.binding = res ? res.bound : null
      this.bindingLoading = false
    },
    openKey (mode) {
      this.dialog_key = { show: true, mode: mode, api_key: '' }
      if (this.$refs.keyForm) this.$refs.keyForm.resetValidation()
    },
    async saveKey () {
      if (!this.$refs.keyForm.validate()) return
      this.actionLoading = true
      const res = this.dialog_key.mode === 'bind'
        ? await this.svc.bindBrsk(this.place, this.dialog_key.api_key)
        : await this.svc.replaceApiKey(this.place, this.dialog_key.api_key)
      this.actionLoading = false
      if (!res.ok) {
        this.$store.commit('snackbar', res.error)
        return
      }
      this.dialog_key.show = false
      this.binding = true
      this.$store.commit(
        'snackbar',
        (this.dialog_key.mode === 'bind' ? 'Ключ привязан: ' : 'Ключ заменён: ') + res.data.api_key_mask
      )
    }
  }
}
</script>
